module.exports = __webpack_public_path__ + "img/money.afb93a8a.svg";